import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import {
	CALENDAR_ENTRY_HEIGHT,
	TABLE_CELL_MARGIN_Y,
	CALENDAR_ENTRY_TYPE_HEIGHT,
} from "Components/Calendar/CalendarEntryHelper";
import useIsInViewport from "use-is-in-viewport";
import { CSSProperties } from "@material-ui/styles";

interface Props {
	scheduleEntryTypesLength?: number;
	renderColumns: () => JSX.Element;
	isSingleRow?: boolean;
}

const CalendarRow: FC<Props> = (props) => {
	const [isInViewport, rowRef] = useIsInViewport();
	const classes = useStyles();

	function getStyle(): CSSProperties {
		return {
			opacity: isInViewport ? 1 : 0,
			height: getRowHeight(props.isSingleRow, props.scheduleEntryTypesLength),
		};
	}

	return (
		<div ref={rowRef} className={classes.root} style={getStyle()}>
			{isInViewport ? props.renderColumns() : null}
		</div>
	);
};

export default CalendarRow;

/**
 * When `scheduleEntryTypesLength` is a number than it's week,
 * Otherwise month.
 */
function getRowHeight(
	isSingleRow?: boolean,
	scheduleEntryTypesLength?: number
) {
	if (scheduleEntryTypesLength) {
	}
	return (
		CALENDAR_ENTRY_HEIGHT +
		TABLE_CELL_MARGIN_Y * 2 +
		(isSingleRow
			? 0
			: CALENDAR_ENTRY_TYPE_HEIGHT * (scheduleEntryTypesLength || 0))
	);
}

const useStyles = makeStyles({
	root: {
		display: "flex",
		transition: "opacity 300ms",
	},
});
